import CircularProgress from '@mui/material/CircularProgress'
import { useStore } from '@nanostores/react'
import clsx from 'clsx'
import * as Scheduled from 'features/scheduled-messages'
import { useId, useRef } from 'react'
import { useSyncPopoverState } from 'shared/hooks/useSyncPopoverState'
import { contextActions } from 'shared/styles'
import { typo } from 'shared/styles'
import { Button, LoadingButton, StackIcon } from 'shared/ui'

import * as files from '../../utils/files'
import { $editMessage } from './form'
import css from './Submit.module.css'

interface CommonProps {
	isLoading?: boolean
	text: string
}

export function SubmitButton(props: CommonProps) {
	const { isLoading, text } = props
	const fileState = useStore(files.$fileState)
	const isFileProgress = fileState === files.FilesState.InProgress
	const isScheduleMode = useStore(Scheduled.$isScheduledShown)
	const edit = useStore($editMessage)

	if (edit) {
		return (
			<>
				<Button className={css.button} type='reset' variant='bordered-dark'>
					Cancel
				</Button>

				<LoadingButton
					className={css.button}
					disabled={text === edit.text || !text || isFileProgress}
					isLoading={isLoading}
					type='submit'
				>
					Save
				</LoadingButton>
			</>
		)
	}

	if (isScheduleMode) {
		return (
			<LoadingButton
				className={css.button}
				disabled={!text || isFileProgress}
				isLoading={isLoading}
				type='submit'
			>
				Schedule
			</LoadingButton>
		)
	}

	return <WithDropDown {...props} />
}

function WithDropDown({ isLoading, text }: CommonProps) {
	const id = useId()
	const popoverRef = useRef<HTMLDivElement | null>(null)
	const fileState = useStore(files.$fileState)

	const isOpened = useSyncPopoverState(popoverRef)

	const isSendDisabled =
		fileState !== files.FilesState.Ready &&
		(fileState === files.FilesState.InProgress ||
			(fileState === files.FilesState.Empty && text.length === 0))

	return (
		<div className={css.root}>
			<button
				aria-label='Send'
				className={clsx(css.main, typo.buttonSmB)}
				disabled={isSendDisabled}
				type='submit'
			>
				{isLoading ? (
					<CircularProgress
						size={12}
						style={{
							color: 'currentcolor'
						}}
					/>
				) : (
					'Send'
				)}
			</button>

			<div
				className={clsx(css.menu, contextActions.menu)}
				id={id}
				// @ts-ignore Recheck in React 19
				popover='auto'
				ref={popoverRef}
			>
				<button
					className={clsx(css.action, contextActions.action)}
					onClick={() => Scheduled.UI.TimePicker.open(text)}
					type='button'
				>
					<StackIcon icon='clock' width={16} />
					Schedule
				</button>
			</div>

			<button
				className={clsx(css.dropdown, isOpened && css.open)}
				disabled={
					isSendDisabled || isLoading || fileState !== files.FilesState.Empty
				}
				// @ts-ignore Recheck in React 19
				popovertarget={id}
				popovertargetaction='toggle'
				type='button'
			>
				<StackIcon className={css.arrow} icon='arrow' width={14} />
			</button>
		</div>
	)
}
